const BASE_URL = '/lishui-gov'
import request from '@/common/api/request'
// 通知列表
export const getListPage = params =>
  request('/lishui-gov/informNotice/getListPage', { params })
//  置顶通知公告
export const topInformNotice = data =>
  request.post('/lishui-gov/informNotice/topInformNotice', data)
// 发布通知公告
export const issueInformNotice = data =>
  request.post('/lishui-gov/informNotice/issueInformNotice', data)
// 删除通知公告
export const deleteInformNotice = data =>
  request.post('/lishui-gov/informNotice/deleteInformNotice', data)
// 新增通知公告
export const addInformNotice = data =>
  request.post('/lishui-gov/informNotice/addInformNotice', data)
// 编辑公告
export const updateInformNotice = data =>
  request.post('/lishui-gov/informNotice/updateInformNotice', data)
// 公告详情
export const getDetailById = params =>
  request('/lishui-gov/informNotice/getDetailById', params)
// 批量发布通知公告
export const issueBatchInformNotice = data =>
  request.post('/lishui-gov/informNotice/issueBatchInformNotice', data)
